import API from "../api/api";
const $API = new API();

export async function downloadDocument(url, name) {
  if (!url || !url.includes("https://md-booking.hmc.co.il/")) return;
  try {
    const res = await $API.getDocApp(url);

    const link = document.createElement("a");
    link.href = res.message;
    link.download = name;

    const isMobile = window.innerWidth < 1200;
    if (isMobile && navigator.userAgent != "hmcAppUserAgent") {
      const response = await fetch(res.message);
      const blob = await response.blob();
      link.href = URL.createObjectURL(blob);
    }

    link.target = "_blank";
    link.click();
  } catch (error) {
    return error;
  }
}
